<template>
  <div
    v-if="assetTrayGrouping"
    class="asset-tray"
  >
    <div
      class="asset-tray-tabs"
    >
      <button
        v-for="(tab) in assetTrayTabs"
        :key="'button-'+tab.id"
        :class="{ 'active': tab.id === activeTabId }"
        @click="activeTabId = tab.id"
      >
        <span v-html="tab.buttonTitle"></span>
      </button>
    </div>
    <div
      class="active-tab-container"
    >
      <div
        v-for="tab in assetTrayTabs"
        v-show="tab.id === activeTabId"
        :key="tab.id"
        class="asset-tray-content"
      >
        <div
          v-for="subTopic in tab.subTopics"
          :key="subTopic.id"
          class="asset-tray-subtopic"
        >
          <p class="subtopic-title">
            <span v-html="subTopic.title"></span>
          </p>
          <div v-html="subTopic.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetTrayMixin from '@/mixins/asset-tray';

export default {
  name: 'AssetTray',
  mixins: [assetTrayMixin],
};
</script>

<style lang="scss" scoped>
.asset-tray {
  margin-top: 2rem;
}

.asset-tray-tabs {
  display: flex;
  gap: 0.375rem;

  button {
    padding: 0.5rem 1rem;
    background: #fff;
    font-size: 1rem;
    font-weight: 700;
    border: 1px solid #000;
    border-bottom: none;
    border-radius: 0.375rem 0.375rem 0 0;

    &.active {
      // z-index: 1;
      box-shadow: 0 1px 0 0 white;
    }
  }
  .new-content-icon {
    transform: translateY(-0.5rem);
  }

}
.subtopic-title {
  font-size: 1rem;
  font-weight: 700;
}

.active-tab-container {
  padding: 1rem;
  border: 1px solid #000;
}

</style>

<style lang="scss">
.asset-tray-subtopic {
  table, th, td {
      border: 1px solid #000000;
      border-collapse: collapse;
    }

    tr:nth-child(odd){
      background-color: #d9e6f4;
      font-weight: 700;
    }

    tr:nth-child(even){
      background-color: white;
      font-weight: 400;
      font-size: 16px;

      td {
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
    }

    th, td {
      padding: 0.625rem;

      *:first-child {
        margin-top: 0;
      }

      *:last-child {
        margin-bottom: 0;
      }
    }

}
</style>
